// Encode for both text content and quoted attributes. textContent→innerHTML
// leaves `"`/`'` intact, which closes attributes (CORE-8575 / SEC-337).
export function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
}

// Only allow http(s) URLs, fragments, and single-slash same-origin paths.
// Protocol-relative URLs (//evil.example) are rejected so an attacker-supplied
// result URL can't redirect off-site, and anything else (javascript:, data:,
// etc.) is dropped so it can't run when the row is clicked. The result is
// HTML-escaped for safe attribute interpolation.
export function safeUrl(value) {
  const url = String(value ?? "").trim()
  if (/^(https?:\/\/|#|\/(?!\/))/i.test(url)) {
    return escapeHtml(url)
  }
  return "#"
}

// HTML-escapes `text` first, then wraps query matches in <strong>. Matching
// happens on the original string so queries with `<` still highlight, then
// each segment is escaped so stored names cannot break into markup.
export function highlightMatch(text, query, minChars = 3) {
  const raw = String(text ?? "")
  if (!query || query.length < minChars) return escapeHtml(raw)

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(`(${escapedQuery})`, "gi")

  return raw.split(regex).map((part, index) => {
    const escaped = escapeHtml(part)
    return index % 2 === 1
      ? `<strong class="searcher__highlight">${escaped}</strong>`
      : escaped
  }).join("")
}
